export const authSelector = (state) => state.auth?.auth;
export const trashSelector = (state) => state.trash;
export const activeProjectSelector = (state) => state.activeProject;
